import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { DEFAULT_CATALOG } from "../config/catalog";
import { useCatalogData } from "../hooks/useCatalogData";

const CatalogContext = createContext(null);

export const CatalogProvider = ({ children }) => {
  const { baseUrl, catalog, health, loading, error, refresh } = useCatalogData();
  const value = useMemo(
    () => ({ baseUrl, catalog, health, loading, error, refresh }),
    [baseUrl, catalog, health, loading, error, refresh]
  );

  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
};

CatalogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCatalog = () => {
  const context = useContext(CatalogContext);
  if (context === null) {
    return {
      catalog: DEFAULT_CATALOG,
      health: null,
      loading: true,
      error: null,
      refresh: () => undefined,
      baseUrl: null,
    };
  }
  return context;
};

export default CatalogContext;
